import { render } from "./App.vue?vue&type=template&id=2812f980"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2812f980&lang=less"

import exportComponent from "/Users/brichriver/workspace/vibe-coding/vue-search-agent/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__